export default "__VITE_ASSET__BLCToaJ6__"